export default "/assets/images/milaair-order-bg-sm.jpg?b9f91fe33bf56900401b2c5b08d1ec4b";